var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.2 14.9",
    style: {
      enableBackground: "new 0 0 21.2 14.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(1 175)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9-160.1c-1.6,0-3.1-1-3.6-2.5l-0.2-0.7H6.2L6-162.6c-0.5,1.5-2,2.5-3.6,2.5c-1.9,0-3.4-1.5-3.4-3.2 c0-0.2,0-0.3,0.1-0.5l1.1-7c0.5-2.6,2.8-4.1,9.5-4.1s9,1.5,9.5,4.1l1.1,7c0,0.2,0,0.4,0,0.5C20.3-161.6,18.8-160.1,16.9-160.1 L16.9-160.1z M8-168.6c0-0.4-0.4-0.8-0.8-0.8H6.1v-1.1c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v1.1H3.5c-0.4,0-0.8,0.4-0.8,0.8 s0.4,0.8,0.8,0.8h1.1v1.1c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-1.1h1.1C7.7-167.8,8-168.2,8-168.6z M14.7-167.1 c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3S14.7-166.3,14.7-167.1z M16.8-170.2c0-0.7-0.6-1.3-1.3-1.3 s-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3S16.8-169.5,16.8-170.2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.7a49ba29.svg";
export { ForwardRef as ReactComponent };